import type { I18nFn } from '#/i18n/types/I18nFn';

export function INTERNSHIP_PAYMENT_TYPE(i18n: I18nFn) {
  return {
    // TRANSLATORS: internship payment type
    HOURLY: i18n('Hourly'),
    // TRANSLATORS: internship payment type
    SALARY: i18n('Salary'),
    // TRANSLATORS: internship payment type
    STIPEND: i18n('Stipend'),
  };
}
